@if (view === 'dialog') {
  <ejs-dialog target=".dialogs" class="selector-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'70%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="false">
    <ng-template #header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
          <app-headline [title]="('DOCUMENTSMYFILES' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('DOCUMENTSMYFILESHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
        <app-form-button (click)="close()" [style]="'btn'" [cssClass]="'btn-close'"></app-form-button>
      </div>
    </ng-template>
    <ng-template #content>
      <div class="base-content custom-scrollbar d-flex flex-wrap mh-100 overflow-y-auto overflow-md-hidden">
        <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 left-container h-100 overflow-y-auto p-3">
          <div class="d-none justify-content-between align-items-center mb-3 d-md-flex">
            <div class="d-flex align-items-center">
              <app-headline [title]="('DOCUMENTSMYFILES' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
              <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('DOCUMENTSMYFILESHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
            </div>
            <app-form-button (click)="close()" [style]="'btn'" [cssClass]="'btn-close'"></app-form-button>
          </div>
          <app-form-input [type]="'search'" [hasErrorField]="false" [placeholder]="('SEARCHINDOCUMENTS' | translate)" [iconFront]="'search'" [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'searchString'" [fG]="documentsCommanderForm"></app-form-input>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-secondary'" class="mt-1 d-block" [style.visibility]="hasSearchQuery() ? 'visible' : 'hidden'"><b>{{ filteredDocuments.length + filteredFolders.length }}</b> {{ ('SEARCHRESULTS' | translate) }}</app-content>
          @if (currentFolder) {
            <div class="d-inline-flex align-items-center gap-1 mt-2">
              <div class="button-placeholder gap-2">
                @if (canGoBack()) {
                  <app-form-button [text]="'BACK' | translate" (click)="folderBack()" [cssClass]="'d-flex align-items-center e-outline e-small fw-bold'" [icon]="'chevron_left'" [iconPosition]="'left'"></app-form-button>
                }
                <app-headline [title]="currentFolder.name" [type]="'h6'" [class]="'text-secondary truncate-text-two-lines fs-default'"></app-headline>
              </div>
            </div>
          }
          <div class="custom-scrollbar overflow-y-auto max-h-100-md max-h-350">
            <div class="d-flex h-100 flex-column">
              <div class="fileFolderListContainer d-flex flex-wrap gap-2 p-2">
                @if (currentFolder) {
                  @for (folder of filteredFolders; track folder) {
                    <app-item-documents-folder [folder]="folder" (folderSelected)="selectFolder(folder)"></app-item-documents-folder>
                  }
                  @for (file of filteredDocuments; track file) {
                    <app-item-documents-preview-available [file]="file" [(files)]="files" [multiple]="multiple" (filesChange)="update($event)"></app-item-documents-preview-available>
                  }
                }
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-12 d-flex flex-column right-container h-100 p-3">
          <div class="text-center mb-3">
            <app-headline [title]="('SELECTEDFILES' | translate)" [type]="'h5'"></app-headline>
          </div>
          <div class="custom-scrollbar">
            <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
              @for (file of files; track file; let i = $index) {
                <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
              }
            </div>
          </div>
          <div class="save-button-container text-center mt-3 d-none d-md-block">
            <app-form-button [text]="'CONTINUE' | translate" (click)="close()" [cssClass]="'e-primary w-100'"></app-form-button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #footerTemplate>
      <div class="mt-auto d-md-none col-12 d-flex justify-content-between p-2">
        <app-form-button [text]="'CONTINUE' | translate" (click)="close()" [cssClass]="'e-primary mx-auto w-100'"></app-form-button>
      </div>
    </ng-template>
  </ejs-dialog>
}


@if (view === 'component') {
  <div class="base-content custom-scrollbar d-flex flex-wrap mh-100 overflow-y-auto overflow-md-hidden">
    <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 left-container h-100 overflow-y-auto p-3">
      <div class="d-none justify-content-between align-items-center mb-3 d-md-flex">
        <div class="d-flex align-items-center">
          <app-headline [title]="('DOCUMENTSMYFILES' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('DOCUMENTSMYFILESHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
        <app-form-button (click)="close()" [style]="'btn'" [cssClass]="'btn-close'"></app-form-button>
      </div>
      <app-form-input [type]="'search'" [hasErrorField]="false" [placeholder]="('SEARCHINDOCUMENTS' | translate)" [iconFront]="'search'" [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'searchString'" [fG]="documentsCommanderForm"></app-form-input>
      <app-content [fontSize]="'fs-small'" [fontColor]="'text-secondary'" class="d-block" [style.visibility]="hasSearchQuery() ? 'visible' : 'hidden'"><b>{{ filteredDocuments.length + filteredFolders.length }}</b> {{ ('SEARCHRESULTS' | translate) }}</app-content>
      @if (currentFolder) {
        <div class="d-inline-flex align-items-center gap-1 mt-2">
          <div class="button-placeholder gap-2">
            @if (canGoBack()) {
              <app-form-button [text]="'BACK' | translate" (click)="folderBack()" [cssClass]="'d-flex align-items-center e-outline e-small fw-bold'" [icon]="'chevron_left'" [iconPosition]="'left'"></app-form-button>
            }
            <app-headline [title]="currentFolder.name" [type]="'h6'" [class]="'text-secondary truncate-text-two-lines fs-default'"></app-headline>
          </div>
        </div>
      }
      <div class="custom-scrollbar overflow-y-auto max-h-100-md max-h-350">
        <div class="d-flex h-100 mb-3 flex-column">
          <div class="fileFolderListContainer d-flex flex-wrap gap-2 p-2">
            @if (currentFolder) {
              @for (folder of filteredFolders; track folder) {
                <app-item-documents-folder [folder]="folder" (folderSelected)="selectFolder(folder)"></app-item-documents-folder>
              }
              @for (file of filteredDocuments; track file) {
                <app-item-documents-preview-available [file]="file" [(files)]="files" [multiple]="multiple" (filesChange)="update($event)"></app-item-documents-preview-available>
              }
            }
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-12 d-flex flex-column right-container h-100 p-3">
      <div class="text-center mb-3">
        <app-headline [title]="('SELECTEDFILES' | translate)" [type]="'h5'"></app-headline>
      </div>
      <div class="custom-scrollbar">
        <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
          @for (file of files; track file; let i = $index) {
            <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
          }
        </div>
      </div>
      <div class="save-button-container text-center mt-3 d-none d-md-block">
        <app-form-button [text]="'CONTINUE' | translate" (click)="close()" [cssClass]="'e-primary w-100'"></app-form-button>
      </div>
    </div>
  </div>
}
